import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-flex tw-flex-col tw-gap-4 tw-p-4" }
const _hoisted_2 = { class: "tw-break-words tw-text-sm" }
const _hoisted_3 = { class: "tw-font-medium" }
const _hoisted_4 = { class: "tw-h-[40px]" }

import { assetsClipRenameClipPartialUpdate } from '@goldcast/api/content';
import logger from '@goldcast/logger';
import { ref } from 'vue';
import { useStore } from 'vuex';

import { renameVideoAsset, VideoAsset } from '../videoLibraryService';

import StudioDialog from '@/studioComponents/StudioDialog.vue';
import StudioInput from '@/studioComponents/StudioInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoLibraryRenamePopup',
  props: {
    videoAsset: {}
  },
  emits: ["close", "success:rename"],
  setup(__props: any, { emit }) {

const props = __props;





const store = useStore();
const newVideoName = ref('');
const isRenaming = ref(false);

const renameClip = () => {
  if (
    props.videoAsset.source === 'CL_UPLOAD' ||
    props.videoAsset.source === 'CLIP' ||
    props.videoAsset.source === 'EVENT_RECORDING' ||
    props.videoAsset.source === 'DIRECT_RECORDING'
  ) {
    return assetsClipRenameClipPartialUpdate({
      body: {
        video_library_id: props.videoAsset.id,
        title: newVideoName.value
      }
    });
  }

  return renameVideoAsset(props.videoAsset.id, newVideoName.value);
};

const handleRename = () => {
  if (!newVideoName.value.trim()) {
    return;
  }

  isRenaming.value = true;

  renameClip()
    .then(() => {
      store.dispatch('studioToast/triggerToast', {
        mode: 'success',
        msg: 'Video renamed successfully.'
      });
      emit('success:rename', { ...props.videoAsset, name: newVideoName.value });
    })
    .catch((errorMessage: string) => {
      logger.error('Error renaming video', errorMessage);
      store.dispatch('studioToast/triggerToast', { mode: 'error', msg: errorMessage });
    })
    .finally(() => {
      isRenaming.value = false;
      emit('close');
    });
};

const handleClose = () => {
  emit('close');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(StudioDialog, {
    title: "Rename Video",
    showCloseButton: "",
    primaryActionTitle: isRenaming.value ? 'Saving...' : 'Save',
    primaryActionDisabled: !newVideoName.value.trim() || isRenaming.value,
    onPrimaryAction: handleRename,
    onClose: handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, [
          _createTextVNode(" New name for "),
          _createElementVNode("span", _hoisted_3, _toDisplayString(props.videoAsset.name), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(StudioInput, {
            id: "videoName",
            modelValue: newVideoName.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newVideoName).value = $event)),
            placeholder: props.videoAsset.name,
            maxlength: 255,
            required: "",
            autofocus: "",
            onKeyup: _withKeys(handleRename, ["enter"])
          }, null, 8, ["modelValue", "placeholder", "onKeyup"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["primaryActionTitle", "primaryActionDisabled"]))
}
}

})